import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";

import { signOut } from "../../api/authRequest";

import Brand from "./Brand";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "../../i18n/TranslationProvider";

const Header = () => {
    const navigate = useNavigate();
    const { logout, isAuthenticated, userProfile } = useAuth();
    const { t } = useTranslation();

    const handleLogout = async () => {
        try {
            await signOut();
        } catch (err) {
            console.error("Logout failed:", err);
        } finally {
            logout();
            navigate("/");
        }
    };

    return (
        <div className="my-4 flex flex-col items-center gap-2">
            <Brand />
            <LanguageSelector />
            {isAuthenticated && (
                <div className="text-center gap-2 mt-2">
                    <h1 className="font-normal text-lg">
                        {t("header.loggedInAs")}
                    </h1>
                    <h2 className="text-lg">
                        {userProfile?.first_name} {userProfile?.last_name}
                    </h2>
                    <div>
                        <button
                            type="button"
                            className="text-teal-600 mt-2 focus:outline-none focus:ring-2 focus:ring-teal-500 rounded"
                            onClick={handleLogout}
                        >
                            {t("header.logout")}
                        </button>
                    </div>
                    <div>
                        <button
                            type="button"
                            className="text-teal-600 mt-2 focus:outline-none focus:ring-2 focus:ring-teal-500 rounded"
                            onClick={() => navigate("/help")}
                        >
                            {t("header.needHelp")}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Header;